<template>
    <div class="securitySetting">
        <div class="info-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index" @click="updateRouter(item.href)" :to="{path: item.href}">
                    <span style="cursor:pointer;">{{item.name}}</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="info-down">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import routesInfo from "@/router/routesInfo.js";
var getRoutesUrlMap = (routes, lastUrlInfos) => {
	if (!routes) {
		return [];
	}
	var urlMap = {};
	routes.forEach(item => {
		var newLastUrlInfos = [
			...lastUrlInfos,
			{
				name: item.name,
				href: item.href
			}
		];
		if (item.href) {
			urlMap[item.href] = newLastUrlInfos;
		}
		if (item.children && item.children.length) {
			urlMap = {
				...urlMap,
				...getRoutesUrlMap(item.children, newLastUrlInfos)
			};
		}
	});

	return urlMap;
};

var routersUrlMap = getRoutesUrlMap(routesInfo, []);
export default {
    name: 'securitySetting',
    data () {
        return {
            routerMap: routersUrlMap,
			breadcrumbList: []
        }
    },
    watch: {
        $route() {
			this.getBreadcrumbList();
		}
    },
    methods : {
        crumbtrigger( route ){
            
        },
        getBreadcrumbList() {
			var fullPath = this.$route.path;
			var breadcrumbList = [];
			if (fullPath) {
				breadcrumbList = this.routerMap[fullPath] || [];
			}
			breadcrumbList = breadcrumbList.map((item, index) => ({
				...item,
				path: `item_${index}`
			}));
			this.breadcrumbList = breadcrumbList;
		},
		updateRouter(path) {
			var fullPath = this.$route.fullPath;
			if (fullPath === path) {
				this.$store.commit("VXRouterViewKey", new Date().getTime());
			} else {
				this.$router.push(path);
			}
		}
    },
    mounted() {
		this.getBreadcrumbList();
	},
}
</script>

<style lang="scss" scoped>
.securitySetting{
    width: 100%; height: 100%; overflow: hidden; display: flex; flex-direction: column;
    .info-top{
        height: 60px; width: 100%; margin-bottom: 16px; background: #ffffff; padding: 20px; line-height: 20px; font-size: 16px; border: 1px solid #e8e8e8;
    }
    .info-down{
        flex: 1; overflow: hidden; background: #ffffff; width: 100%; border: 1px solid #e8e8e8;
    }
}
</style>
<style>
.el-breadcrumb .el-breadcrumb__item span{
    font-size: 16px;
}
.el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
    font-weight: 400;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
    color: #737475;
}
</style>




// WEBPACK FOOTER //
// src/components/securitySetting.vue